/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetSimpleDutyRosterPeriodStatusesByIdsParams,
  GetWeekStatusParams,
  SetDepartmentStatusRequest,
  SetWorkAreaStatusRequest,
  SimpleDutyRosterPeriodStatus
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getSetWorkAreaWeekStatusUrl = () => {




  return `/api/PeriodStatusService/SetWorkAreaWeekStatus`
}

export const setWorkAreaWeekStatus = async (setWorkAreaStatusRequest?: SetWorkAreaStatusRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetWorkAreaWeekStatusUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setWorkAreaStatusRequest)
  }
);}





export const getSetWorkAreaWeekStatusMutationKey = () => ['setWorkAreaWeekStatus'] as const;

export const getSetWorkAreaWeekStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWorkAreaWeekStatus>>, TError,SetWorkAreaWeekStatusMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setWorkAreaWeekStatus>>, TError,SetWorkAreaWeekStatusMutationVariables, TContext> => {

const mutationKey = getSetWorkAreaWeekStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setWorkAreaWeekStatus>>, SetWorkAreaWeekStatusMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setWorkAreaWeekStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetWorkAreaWeekStatusMutationResult = NonNullable<Awaited<ReturnType<typeof setWorkAreaWeekStatus>>>
    export type SetWorkAreaWeekStatusMutationBody = BodyType<SetWorkAreaStatusRequest> | undefined
    export type SetWorkAreaWeekStatusMutationError = ErrorType<unknown>
    export type SetWorkAreaWeekStatusMutationVariables = {data?: BodyType<SetWorkAreaStatusRequest>}

    export const useSetWorkAreaWeekStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWorkAreaWeekStatus>>, TError,SetWorkAreaWeekStatusMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setWorkAreaWeekStatus>>,
        TError,
        SetWorkAreaWeekStatusMutationVariables,
        TContext
      > => {
      return useMutation(getSetWorkAreaWeekStatusMutationOptions(options), queryClient);
    }
    export const getSetDepartmentWeekStatusUrl = () => {




  return `/api/PeriodStatusService/SetDepartmentWeekStatus`
}

export const setDepartmentWeekStatus = async (setDepartmentStatusRequest?: SetDepartmentStatusRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetDepartmentWeekStatusUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setDepartmentStatusRequest)
  }
);}





export const getSetDepartmentWeekStatusMutationKey = () => ['setDepartmentWeekStatus'] as const;

export const getSetDepartmentWeekStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDepartmentWeekStatus>>, TError,SetDepartmentWeekStatusMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDepartmentWeekStatus>>, TError,SetDepartmentWeekStatusMutationVariables, TContext> => {

const mutationKey = getSetDepartmentWeekStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDepartmentWeekStatus>>, SetDepartmentWeekStatusMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setDepartmentWeekStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDepartmentWeekStatusMutationResult = NonNullable<Awaited<ReturnType<typeof setDepartmentWeekStatus>>>
    export type SetDepartmentWeekStatusMutationBody = BodyType<SetDepartmentStatusRequest> | undefined
    export type SetDepartmentWeekStatusMutationError = ErrorType<unknown>
    export type SetDepartmentWeekStatusMutationVariables = {data?: BodyType<SetDepartmentStatusRequest>}

    export const useSetDepartmentWeekStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDepartmentWeekStatus>>, TError,SetDepartmentWeekStatusMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDepartmentWeekStatus>>,
        TError,
        SetDepartmentWeekStatusMutationVariables,
        TContext
      > => {
      return useMutation(getSetDepartmentWeekStatusMutationOptions(options), queryClient);
    }
    export const getGetSimpleDutyRosterPeriodStatusesByIdsUrl = (params: GetSimpleDutyRosterPeriodStatusesByIdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/PeriodStatusService/GetSimpleDutyRosterPeriodStatusesByIds?${stringifiedParams}` : `/api/PeriodStatusService/GetSimpleDutyRosterPeriodStatusesByIds`
}

export const getSimpleDutyRosterPeriodStatusesByIds = async (params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleDutyRosterPeriodStatus[]> => {

  return customInstance<SimpleDutyRosterPeriodStatus[]>(getGetSimpleDutyRosterPeriodStatusesByIdsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimpleDutyRosterPeriodStatusesByIdsQueryKey = (params?: GetSimpleDutyRosterPeriodStatusesByIdsParams,) => {
    return [
    `/api/PeriodStatusService/GetSimpleDutyRosterPeriodStatusesByIds`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimpleDutyRosterPeriodStatusesByIdsQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleDutyRosterPeriodStatusesByIdsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>> = ({ signal }) => getSimpleDutyRosterPeriodStatusesByIds(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimpleDutyRosterPeriodStatusesByIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>>
export type GetSimpleDutyRosterPeriodStatusesByIdsQueryError = ErrorType<unknown>


export function useGetSimpleDutyRosterPeriodStatusesByIds<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleDutyRosterPeriodStatusesByIds<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleDutyRosterPeriodStatusesByIds<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleDutyRosterPeriodStatusesByIds<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleDutyRosterPeriodStatusesByIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleDutyRosterPeriodStatusesByIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleDutyRosterPeriodStatusesByIdsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>> = ({ signal }) => getSimpleDutyRosterPeriodStatusesByIds(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimpleDutyRosterPeriodStatusesByIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>>
export type GetSimpleDutyRosterPeriodStatusesByIdsSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleDutyRosterPeriodStatusesByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleDutyRosterPeriodStatusesByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleDutyRosterPeriodStatusesByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleDutyRosterPeriodStatusesByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleDutyRosterPeriodStatusesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleDutyRosterPeriodStatusesByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleDutyRosterPeriodStatusesByIdsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWeekStatusUrl = (params: GetWeekStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/PeriodStatusService/GetWeekStatus?${stringifiedParams}` : `/api/PeriodStatusService/GetWeekStatus`
}

export const getWeekStatus = async (params: GetWeekStatusParams, options?: Parameters<typeof customInstance>[1]): Promise<number | null> => {

  return customInstance<number | null>(getGetWeekStatusUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWeekStatusQueryKey = (params?: GetWeekStatusParams,) => {
    return [
    `/api/PeriodStatusService/GetWeekStatus`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWeekStatusQueryOptions = <TData = Awaited<ReturnType<typeof getWeekStatus>>, TError = ErrorType<unknown>>(params: GetWeekStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWeekStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeekStatus>>> = ({ signal }) => getWeekStatus(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWeekStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getWeekStatus>>>
export type GetWeekStatusQueryError = ErrorType<unknown>


export function useGetWeekStatus<TData = Awaited<ReturnType<typeof getWeekStatus>>, TError = ErrorType<unknown>>(
 params: GetWeekStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWeekStatus>>,
          TError,
          Awaited<ReturnType<typeof getWeekStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWeekStatus<TData = Awaited<ReturnType<typeof getWeekStatus>>, TError = ErrorType<unknown>>(
 params: GetWeekStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWeekStatus>>,
          TError,
          Awaited<ReturnType<typeof getWeekStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWeekStatus<TData = Awaited<ReturnType<typeof getWeekStatus>>, TError = ErrorType<unknown>>(
 params: GetWeekStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWeekStatus<TData = Awaited<ReturnType<typeof getWeekStatus>>, TError = ErrorType<unknown>>(
 params: GetWeekStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWeekStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWeekStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWeekStatus>>, TError = ErrorType<unknown>>(params: GetWeekStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWeekStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeekStatus>>> = ({ signal }) => getWeekStatus(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetWeekStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWeekStatus>>>
export type GetWeekStatusSuspenseQueryError = ErrorType<unknown>


export function useGetWeekStatusSuspense<TData = Awaited<ReturnType<typeof getWeekStatus>>, TError = ErrorType<unknown>>(
 params: GetWeekStatusParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWeekStatusSuspense<TData = Awaited<ReturnType<typeof getWeekStatus>>, TError = ErrorType<unknown>>(
 params: GetWeekStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWeekStatusSuspense<TData = Awaited<ReturnType<typeof getWeekStatus>>, TError = ErrorType<unknown>>(
 params: GetWeekStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWeekStatusSuspense<TData = Awaited<ReturnType<typeof getWeekStatus>>, TError = ErrorType<unknown>>(
 params: GetWeekStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWeekStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWeekStatusSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






